import { __assign, __read, __spread } from "tslib";
import axios from 'axios';
import { camelCase, snakeCase } from 'lodash';
import { deepMapKeys } from './utils';
export default (function (opts) {
    if (opts === void 0) { opts = {}; }
    return axios.create(__assign(__assign({}, opts), { timeout: 10000, transformRequest: __spread((Array.isArray(axios.defaults.transformRequest) ? axios.defaults.transformRequest : []), [
            function (data) {
                try {
                    var parsed = JSON.parse(data);
                    var transformed = deepMapKeys(parsed, function (_, key) {
                        switch (key) {
                            case 'addressLine1':
                                return 'address_line1';
                            case 'addressLine2':
                                return 'address_line2';
                            default:
                                return typeof key === 'string' ? snakeCase(key) : key;
                        }
                    });
                    return JSON.stringify(transformed);
                }
                catch (err) {
                    return data;
                }
            },
        ]), transformResponse: [
            function (data) {
                try {
                    var parsed = JSON.parse(data);
                    return deepMapKeys(parsed, function (_, key) { return camelCase(key); });
                }
                catch (err) {
                    return data;
                }
            },
        ] }));
});
//# sourceMappingURL=http.js.map